/** Universelle Zieltypen der mandantenbezogenen Dokumentenablage. */
export const DMS_ENTITY_TYPES = [
    'GENERAL',
    'PRODUCT',
    'PARTNER',
    'DOCUMENT',
    'BATCH',
    'EXPENSE',
    'QUESTIONNAIRE_RUN',
    'FEEDBACK',
    'RECIPE',
    'PROCESS_ROUTING',
    'ANALYSIS_PROFILE',
    'PRODUCTION_ORDER',
    'LABEL_PRINT',
    'CHANGE_REQUEST',
    'DUNNING',
    'NEWSLETTER',
    'IMPORT',
    'MIGRATION_EVIDENCE',
    'BANK_STATEMENT',
    'SALES_TASK',
];
export const DMS_CATEGORIES = [
    'GENERAL_FILE',
    'CONTRACT',
    'CERTIFICATE',
    'DATASHEET',
    'INVOICE_RECEIPT',
    'CORRESPONDENCE',
    'CUSTOMS_DECLARATION',
    'IMAGE',
    'BANK_STATEMENT',
];
export const DMS_MAX_FILE_BYTES = 50 * 1024 * 1024;
export const DMS_MAX_FILES_PER_SELECTION = 20;
export const DMS_MAX_TAGS = 20;
export const DMS_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/avif',
    'text/plain',
    'text/csv',
    'application/xml',
    'text/xml',
    'application/zip',
    'application/vnd.swift.mt940',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
/** Erweiterungen dienen zusätzlich zur MIME-Prüfung als Schutz vor falsch benannten Uploads. */
export const DMS_EXTENSIONS_BY_MIME = {
    'application/pdf': ['.pdf'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
    'image/avif': ['.avif'],
    'text/plain': ['.txt', '.log', '.sta', '.mt940'],
    'text/csv': ['.csv'],
    'application/xml': ['.xml', '.camt'],
    'text/xml': ['.xml', '.camt'],
    'application/zip': ['.zip'],
    'application/vnd.swift.mt940': ['.sta', '.mt940', '.txt'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};
//# sourceMappingURL=dms.js.map